import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import { auth } from './config/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import LandingPage from "./components/LandingPage/LandingPage";
import SignIn from "./components/Authentication/SignIn";
import SignUp from "./components/Authentication/SignUp";
import ResetPassword from "./components/Authentication/ResetPassword";
import HomePage from "./components/HomePage/HomePage";
import ContactUs from "./components/ContactUs/ContactUs";

function AppContent() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
      
      // Only navigate to home if we're on auth-related pages
      if (user && (location.pathname === '/sign-in' || location.pathname === '/sign-up')) {
        navigate('/home');
      }
    });

    return () => unsubscribe();
  }, [navigate, location.pathname]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-800">
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/sign-in" element={!user ? <SignIn /> : <Navigate to="/home" />} />
        <Route path="/sign-up" element={!user ? <SignUp /> : <Navigate to="/home" />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/home" element={user ? <HomePage /> : <Navigate to="/sign-in" />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;